module.exports = __webpack_public_path__ + "static/img/teacher_info.28f6a456.png";